import { executeQuery } from "src/store";
import { baseService } from "src/store/base.store";
import { taskFailuresRepository } from "./task-failures.repository";
import { TaskFailure, TaskFailuresPage, TaskFailuresQuery } from "./types/task-failure.entity";

const taskFailuresService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getTaskFailures: builder.query<TaskFailuresPage, TaskFailuresQuery>({
      queryFn: async ({ offset }) => {
        const result = await executeQuery(() => taskFailuresRepository.find(offset));

        if ("error" in result) return { error: result.error } as any;
        return { data: result.data as TaskFailuresPage };
      },
    }),

    getTaskFailureById: builder.query<TaskFailure | undefined, string>({
      queryFn: async (id) => {
        const result = await executeQuery(() => taskFailuresRepository.findById(id));

        if ("error" in result) return { error: result.error } as any;
        return { data: result.data };
      },
    }),
  }),
});

export const { useGetTaskFailureByIdQuery, useGetTaskFailuresQuery } = taskFailuresService;
